import {Component, HostListener, Inject,Input,input,OnInit, ViewChild,} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { SettingsService } from '../settings/settings.service';
import { ConfirmDialog } from './dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MenuSimpli } from './menu-simpli/menu.simpli';
import { CommonModule } from '@angular/common';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../material/material.module';
import { InversionistaDataSimulacionService } from '../simulacion/services/inversionista-data-simulacion.service';
import { UploadAvatarComponent } from './upload-avatar/upload-avatar.component';

declare var $: any;

@Component({
  selector: 'app-layout',
  standalone:true,
  imports:[MenuSimpli, RouterModule, CommonModule, MatSidenavModule, MaterialModule],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less'],
})
export class LayoutComponent implements OnInit {

  opened: boolean = true;
  full_name: string = '';
  selectedOption: string = '';
  showSpinner: boolean = true;
  mobileQuery!: MediaQueryList;
  mode: any = 'side';
  display: boolean = true;
  token: any;



  initials: string = '';
  avatar: string = "";
  hasAvatar: boolean = false;


  rol: any;

 
  rut: any;
  razon_social: any;
  fecha_completa: any;

  Companies: any[] = [];
  run: any;





  open_menu() {
    this.opened = !this.opened;

    if (!this.opened) {
      $('.logo_home').addClass('logo_home_active');
    } else {
      $('.logo_home').removeClass('logo_home_active');
    }
  }

  mouseleave($event: any) {
    $('#menupagoproveedores').css('display', 'none');
  }

  cuenta() {
    this.router.navigate(['home/info']);
  }

  contrasena() {
    this.router.navigate(['home/change-password']);
  }

  
  constructor(
    private router: Router,
    public dialog: MatDialog,
    public settings: SettingsService,
    fb: FormBuilder,
    public snackbar: MatSnackBar,
    private inversionistaDataSimulacionService: InversionistaDataSimulacionService,
  ) {



    this.token = localStorage.getItem('token');

  }

  is_responsive: boolean = false;
  menu_cliente: boolean = true;
  menu_confirming_pronto_pago: boolean = false;
  ngOnInit() {
    if ($(window).width() <= 1024) {
      this.is_responsive = true;
    }

    this.verify();
    this.get_personal_data();
    this.get_time_webinar();

    if ($(window).width() < 768) {
      this.mode = 'over';
      this.opened = false;
    }

    this.rol = localStorage.getItem('role');
    if (this.rol == 'clie') {
      this.menu_cliente = true;
      this.menu_confirming_pronto_pago = false;
    } else if (this.rol == 'conf' || this.rol == 'prpa') {
      this.menu_cliente = false;
      this.menu_confirming_pronto_pago = true;
    }

  }

  close_menu($event:any){
    console.log($event)

  }

  go_info() {
    this.router.navigate(['home/info']);
  }

  verify() {
    if (localStorage.getItem('token') == null) {
      this.router.navigate(['login']);
    }
  }

  activate_chat: boolean = false;
  name: any = '';
  async get_personal_data() {
    try {
      const bd: any = await this.settings.get_query(1, '/cliente-inversionista/current-user/');
      var body_data: any = bd._body;
      switch (bd.status) {
        case 200:

        console.log("body_data", body_data)

          this.avatar = body_data.info.user.avatar;

          this.activate_chat = body_data.info.activate_chat
          this.initials =
            body_data.info.user.first_name.charAt(0) +
            body_data.info.user.last_name.charAt(0);
          this.full_name =
            body_data.info.user.first_name.split(' ')[0] +
            ' ' +
            body_data.info.user.last_name.split(' ')[0];
          this.run = body_data.info.user.run;

          this.inversionistaDataSimulacionService.setInversionistaDataSimulacion({
            full_name: this.full_name,
            run: this.run,
            email: body_data.info.user.email,
            telefono: body_data.info.user.phone?.number || '',
          })

          if (body_data.info.user.type_avatar == 0) {
            this.hasAvatar = false
          } else {
            this.hasAvatar = true
          }

          localStorage.setItem(
            'full_name',
            body_data.info.user.first_name.split(' ')[0]
          );
          localStorage.setItem('user_id', body_data.info.user.id);
      

          this.name = body_data.info.user.first_name;


          break;
        default:

          break;
      }
    } catch (bd: any) {

      console.log("error", bd);

      localStorage.clear();
      this.router.navigateByUrl('/login');

    }
  }



  

  findObjectByKey(array: any, key: any, value: any) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }

  nombre_executive: any;
  executive_mail_to: any;
  executive_cel: any;
  executive_mail: any;
  url_qr: any;
  src_image: any;
  

  TextAbstract(text: any, length: any) {
    if (text == null) {
      return '';
    }
    if (text.length <= length) {
      return text;
    }
    text = text.substring(0, length);
    var last = text.lastIndexOf(' ');
    text = text.substring(0, last);
    return text + '..';
  }

  show_snak(){
    this.snackbar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
      duration: 20000,
      panelClass: 'simpli-snack'
    });
  }

  showLabel1!: boolean;
  showLabel2!: boolean;
  showLabel3!: boolean;
  go_to_webinar(){
    window.open("https://www.youtube.com/live/oC1OAxx8zIM?si=XcSwEC9VdGUPDmYa", "_blank")
  }

  get_time_webinar(){
    const now = new Date();
    const march22_2024_10_59AM = new Date(2024, 2, 22, 10, 59);
    const march22_2024_11AM = new Date(2024, 2, 22, 11, 0);
    const march22_2024_14PM = new Date(2024, 2, 22, 14, 0);

    this.showLabel1 = now <= march22_2024_14PM;
    this.showLabel2 = now <= march22_2024_10_59AM;
    this.showLabel3 = now >= march22_2024_11AM && now <= march22_2024_14PM;

  }

  capitalizeName(): string {
    if (!this.name) return '';
    return this.name.charAt(0).toUpperCase() + this.name.slice(1).toLowerCase();
  }

  upload_avatar(){
    const dialogRef = this.dialog.open(UploadAvatarComponent, {
      width: '600px',
      data: {
        avatar: this.avatar
      }
    });
    dialogRef.componentInstance.token = this.token;

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.get_personal_data();
      }
    });
  }
}


